import styles from './Tabs.style';

class Tab extends React.Component {
  onClick = () => {
    this.props.onClick(this.props.index);
  };

  render() {
    const { classes, label, selected } = this.props;
    const wrapperClassName = classnames(classes.tab, {
      [classes.tabSelected]: selected,
    });
    const labelClassName = classnames(classes.label, {
      [classes.labelSelected]: selected,
    });

    return (
      <div className={wrapperClassName} onClick={this.onClick}>
        <div className={labelClassName}>{label}</div>
      </div>
    );
  }
}

class Tabs extends React.Component {
  render() {
    const { children, classes, onChange, value } = this.props;

    return (
      <div className={classes.tabs}>
        {React.Children.map(children, (child, index) => {
          return React.cloneElement(child, {
            classes,
            onClick: onChange,
            index,
            selected: value === index,
          });
        })}
      </div>
    );
  }
}

Tabs.propTypes = {
  children: PropTypes.array.isRequired,
  classes: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.number.isRequired,
};

export { Tab };
export default withStyles(styles)(Tabs);
